import { User } from '../types';

export const authService = {
  getToken(): string | null {
    return localStorage.getItem('token');
  },

  setToken(token: string): void {
    localStorage.setItem('token', token);
  },

  removeToken(): void {
    localStorage.removeItem('token');
  },

  getUser(): User | null {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    try {
      return JSON.parse(userStr);
    } catch {
      // Corrupt entry (partial write, manual edit) — this runs during render in
      // the route guards and drawer, so throwing here would white-screen the app
      localStorage.removeItem('user');
      return null;
    }
  },

  setUser(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
  },

  removeUser(): void {
    localStorage.removeItem('user');
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },

  isSuperAdmin(): boolean {
    const user = this.getUser();
    return user?.role === 'superadmin';
  },

  isFaculty(): boolean {
    const user = this.getUser();
    return user?.role === 'faculty';
  },

  /** Staff = faculty or superadmin. Gates document management. */
  isStaff(): boolean {
    return this.isFaculty() || this.isSuperAdmin();
  },

  /**
   * Guard for /chat — every authenticated role may use the assistant,
   * so students, faculty and superadmins all pass.
   */
  isUser(): boolean {
    const user = this.getUser();
    return user?.role === 'user' || user?.role === 'faculty' || user?.role === 'superadmin';
  },

  logout(): void {
    this.removeToken();
    this.removeUser();
  },
};
